import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "react-bootstrap";

interface ILoadingProps {
    Message: string;
    SpinSize: SizeProp;
}

const Loading = (props: ILoadingProps) => {
    return (
        <div className="w-100 h-100 p-3 text-center d-flex flex-column justify-content-center align-items-center">
            <Row className="w-100 justify-content-center">
              <Col xs={12}>
                <FontAwesomeIcon icon={faCircleNotch} size={props.SpinSize} spin={true} className="grey-spinner" />
              </Col>
            </Row>
            <Row className="mt-1 text-center w-100 justify-content-center">
              <Col xs={12}>
                <span className="text-secondary">{props.Message}</span>
              </Col>
            </Row>
        </div>
    );
}

export default Loading;
